/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { history } from "../../config/stores";
import { connect } from "react-redux";
import { logOut } from "../../actions";
import "./styles.scss";
import { User } from "../../utilites/User";
import ArrowDown from "../../assets/icons/arrow-down.svg";
import exportIcon from "../../assets/icons/export_file_icon.svg";
import headerMessageIcon from "../../assets/icons/header-message-icon.svg";

function useOutsideAlerter(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
}

const Header = ({ ref, logOut }) => {
  const location = useLocation().pathname;
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAppSubmenu, setShowAppSubmenu] = useState(false);

  const wrapperRef = useRef(null);
  const appSubmenuRef = useRef(null);

  useOutsideAlerter(wrapperRef, () => {
    setShowDropdown(false);
  });

  useOutsideAlerter(appSubmenuRef, () => {
    setShowAppSubmenu(false);
  });

  const isInAppSection = location.startsWith('/app');

  // Resolve current user, display name, and initials fallback
  const currentUser = User.getUser() || {};
  const displayName = currentUser.fullName || currentUser.name || currentUser.email || "";
  const getInitials = (nameOrEmail) => {
    if (!nameOrEmail) return "U";
    const name = String(nameOrEmail).trim();
    // If looks like an email, use the first character before @
    if (name.includes("@")) return name.charAt(0).toUpperCase();
    const parts = name.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    const first = parts[0].charAt(0);
    const last = parts[parts.length - 1].charAt(0);
    return (first + last).toUpperCase();
  };

  return (
    <>
      {/* ✅ Main Header Container */}
      <div className="header-container">
        <div className="left-header-container">
          <div className="logo" onClick={() => history.push("/")} />
        </div>

        <div className={`middle-header-container`}>
          {/* Dashboard */}
          <div
            className={`header-element ${location === "/" && "selected"}`}
            onClick={() => history.push("/")}
          >
            <div
              className={`header-inner-element ${location === "/" && "selected"}`}
            >
              DASHBOARD
            </div>
          </div>

          {/* APP with Dropdown */}
          <div className={`app-dropdown-container ${isInAppSection && "selected"}`}>
            <div
              className={`header-element ${isInAppSection && "selected"}`}
              onClick={() => setShowAppSubmenu(!showAppSubmenu)}
            >
              <div
                className={`header-inner-element ${isInAppSection && "selected"}`}
              >
                APP
                <img 
                  src={ArrowDown} 
                  alt="dropdown arrow"
                  className={`dropdown-arrow ${showAppSubmenu ? 'rotated' : ''}`}
                />
              </div>
            </div>
          </div>

          {/* Website */}
          <div
            className={`header-element ${location === "/website" && "selected"}`}
            onClick={() => history.push("/website")}
          >
            <div
              className={`header-inner-element ${
                location === "/website" && "selected"
              }`}
            >
              WEBSITE
            </div>
          </div>

          {/* Finances */}
          <div
            className={`header-element ${location === "/finances" && "selected"}`}
            onClick={() => history.push("/finances")}
          >
            <div
              className={`header-inner-element ${
                location === "/finances" && "selected"
              }`}
            >
              FINANCES
            </div>
          </div>
        </div>

        <div className="right-container">
          <div className="header-icons">
            <button
              type="button"
              className="header-icon-btn border-green"
              title="Export"
              aria-label="Export"
              onClick={() => { /* TODO: hook export action if needed */ }}
            >
              <img src={exportIcon} alt="Export" width={18} height={18} />
            </button>
            <button
              type="button"
              className="header-icon-btn border-blue"
              title="Messages"
              aria-label="Messages"
              onClick={() => { /* TODO: open messages center if needed */ }}
            >
              <img src={headerMessageIcon} alt="Messages" width={18} height={18} />
            </button>
          </div>
          <button
            type="button"
            className={`profile-trigger ${showDropdown ? "active" : ""}`}
            aria-haspopup="true"
            aria-expanded={showDropdown}
            title={displayName || "Profile"}
            onClick={() => setShowDropdown((v) => !v)}
          >
            {currentUser?.coverPhoto ? (
              <img
                src={currentUser.coverPhoto}
                alt={displayName || "User"}
                className="avatar-img"
              />
            ) : (
              <span className="avatar-initials" aria-hidden>
                {getInitials(displayName)}
              </span>
            )}
          </button>
          {showDropdown && (
            <>
              <div
                className="dropdown-content"
                ref={wrapperRef}
                id="drowdown-content"
              >
                <div className="profile">
                  <div className="text">Menu</div>
                  <div
                    className="exit"
                    onClick={() => {
                      setShowDropdown(false);
                    }}
                  ></div>
                </div>
                <div className="info">
                  <div className="avatar" />
                  <div
                    style={{
                      height: "100%",
                      width: "91%",
                      padding: "0.6vw",
                      marginLeft: "3%",
                    }}
                  >
                    {" "}
                    <div className="name">
                      <b>{User.getUser().fullName}</b>
                    </div>
                    <div className="phone-number">{User.getUser().email}</div>
                  </div>
                </div>
                <div
                  className="user-management"
                  onClick={() => {
                    history.push("/user-management");
                    setShowDropdown(false);
                  }}
                >
                  <div className="user-management-text">User managment</div>
                  <div className="user-management-icon" />
                </div>
                <div
                  className="user-management"
                  style={{ margin: "10px 8px" }}
                  onClick={() => {
                    history.push("/merchants");
                    setShowDropdown(false);
                  }}
                >
                  <div className="user-management-text">Merchants</div>
                  <div className="merchants-icon" />
                </div>
                <div
                  className="log-out"
                  onClick={() => {
                    logOut();
                    history.push("/login");
                  }}
                >
                  <div className="log-out-text">Log out</div>
                  <div className="log-out-icon"></div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* ✅ APP Submenu - NOW OUTSIDE header container */}
      {showAppSubmenu && (
        <div className="app-submenu-dropdown" ref={appSubmenuRef}>
          <div
            className={`app-submenu-item ${location.includes('/app/properties') && "selected"}`}
            onClick={() => {
              history.push('/app/properties');
              setShowAppSubmenu(false);
            }}
          >
            PROPERTIES
          </div>
          <div
            className={`app-submenu-item ${location.includes('/app/finances') && "selected"}`}
            onClick={() => {
              history.push('/app/finances');
              setShowAppSubmenu(false);
            }}
          >
            FINANCES
          </div>
          <div
            className={`app-submenu-item ${location.includes('/app/communities') && "selected"}`}
            onClick={() => {
              history.push('/app/communities');
              setShowAppSubmenu(false);
            }}
          >
            COMMUNITIES
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.login.token,
});
const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(logOut()),
});
export default connect(null, mapDispatchToProps)(Header);